var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeWhiteColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1.66634C4.5 1.48225 4.64923 1.33301 4.83333 1.33301C5.01743 1.33301 5.16667 1.48225 5.16667 1.66634V3.66634C5.16667 3.85044 5.01743 3.99967 4.83333 3.99967C4.64923 3.99967 4.5 3.85044 4.5 3.66634V1.66634Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83325 1.66634C9.83325 1.48225 9.98249 1.33301 10.1666 1.33301C10.3507 1.33301 10.4999 1.48225 10.4999 1.66634V3.66634C10.4999 3.85044 10.3507 3.99967 10.1666 3.99967C9.98249 3.99967 9.83325 3.85044 9.83325 3.66634V1.66634Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16659 7.66667H4.49992V8.33333H5.16659V7.66667ZM4.49992 7C4.13172 7 3.83325 7.29847 3.83325 7.66667V8.33333C3.83325 8.70153 4.13172 9 4.49992 9H5.16659C5.53479 9 5.83325 8.70153 5.83325 8.33333V7.66667C5.83325 7.29847 5.53479 7 5.16659 7H4.49992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 7.66667H7.16667V8.33333H7.83333V7.66667ZM7.16667 7C6.79847 7 6.5 7.29847 6.5 7.66667V8.33333C6.5 8.70153 6.79847 9 7.16667 9H7.83333C8.20153 9 8.5 8.70153 8.5 8.33333V7.66667C8.5 7.29847 8.20153 7 7.83333 7H7.16667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 7.66667H9.83341V8.33333H10.5001V7.66667ZM9.83341 7C9.46521 7 9.16675 7.29847 9.16675 7.66667V8.33333C9.16675 8.70153 9.46521 9 9.83341 9H10.5001C10.8683 9 11.1667 8.70153 11.1667 8.33333V7.66667C11.1667 7.29847 10.8683 7 10.5001 7H9.83341Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16659 10.3337H4.49992V11.0003H5.16659V10.3337ZM4.49992 9.66699C4.13172 9.66699 3.83325 9.96546 3.83325 10.3337V11.0003C3.83325 11.3685 4.13172 11.667 4.49992 11.667H5.16659C5.53479 11.667 5.83325 11.3685 5.83325 11.0003V10.3337C5.83325 9.96546 5.53479 9.66699 5.16659 9.66699H4.49992Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 10.3337H7.16667V11.0003H7.83333V10.3337ZM7.16667 9.66699C6.79847 9.66699 6.5 9.96546 6.5 10.3337V11.0003C6.5 11.3685 6.79847 11.667 7.16667 11.667H7.83333C8.20153 11.667 8.5 11.3685 8.5 11.0003V10.3337C8.5 9.96546 8.20153 9.66699 7.83333 9.66699H7.16667Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50008 3.33366H11.5001C11.8683 3.33366 12.1667 3.63213 12.1667 4.00033V9.33366C12.3969 9.33366 12.6203 9.36283 12.8334 9.41766V4.00033C12.8334 3.26395 12.2364 2.66699 11.5001 2.66699H3.50008C2.7637 2.66699 2.16675 3.26395 2.16675 4.00033V12.0003C2.16675 12.7367 2.7637 13.3337 3.50008 13.3337H9.85685C9.73748 13.1273 9.64498 12.9035 9.58408 12.667H3.50008C3.13189 12.667 2.83341 12.3685 2.83341 12.0003V4.00033C2.83341 3.63213 3.13189 3.33366 3.50008 3.33366Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.33366H2.5V5.66699H12.5V6.33366Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1667 13.9997C13.2712 13.9997 14.1667 13.1042 14.1667 11.9997C14.1667 10.8951 13.2712 9.99967 12.1667 9.99967C11.0621 9.99967 10.1667 10.8951 10.1667 11.9997C10.1667 13.1042 11.0621 13.9997 12.1667 13.9997ZM12.1667 14.6663C13.6394 14.6663 14.8333 13.4724 14.8333 11.9997C14.8333 10.5269 13.6394 9.33301 12.1667 9.33301C10.6939 9.33301 9.5 10.5269 9.5 11.9997C9.5 13.4724 10.6939 14.6663 12.1667 14.6663Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1666 10.3926C12.3507 10.3926 12.4999 10.5418 12.4999 10.7259V12.1586L13.3171 12.7258C13.4683 12.8308 13.5058 13.0385 13.4008 13.1897C13.2959 13.341 13.0882 13.3785 12.9369 13.2735L11.8333 12.5074V10.7259C11.8333 10.5418 11.9825 10.3926 12.1666 10.3926Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeWhiteColor);
export default __webpack_public_path__ + "static/media/TimeWhiteColor.dcfff4930a51a9e0a240dfd67f8aaae1.svg";
export { ForwardRef as ReactComponent };